/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
import Vue from 'vue';
import taskRouter from './router/task';
import config, { resetConfig } from './config'; //全局环境变量
// Declare install function executed by Vue.use()
export function install(Vue, router, resetRouter, getGlobalConfig) {
  if (install.installed || !getGlobalConfig) return;
  install.installed = true;
  resetConfig(getGlobalConfig());
  const { routes } = router.options;
  resetRouter();
  for (const iterator of routes) {
    if (iterator.path === '/') {
      iterator.children.push(...taskRouter);
    }
  }
  setTimeout(() => {
    resetRouter();
  }, 0);
  //   routeData.children = [...routeData.children, ...taskRouter]
  //   router.addRoute(routeData)
}
// Create module definition for Vue.use()
const plugin = { install };

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
export default {
  install,
  Vue
};
